
import base from './mixin'

export default {
  mixins: [base],
  data () {
    return {
      chartName: 'bar'
    }
  }
}
